import HttpService from './baseHttp'
//分页查询
export const HttpHolidayList = (data) => HttpService.get('/api/v2/holiday/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpSaveHoliday = (data) => HttpService.post('/api/v2/holiday/saveAndUpdate', data, { headers: { "Content-Type": "application/json" },baseURL:process.env.VUE_APP_APIURL_FBB});

export const HttpGetOne = (data = {}) => HttpService.get("/api/v2/holiday/detail", { params: data, baseURL:process.env.VUE_APP_APIURL_FBB });

export const HttpDeleteHolidayOne = (data = {}) => HttpService.get("/api/v2/holiday/delete", { params: data, baseURL:process.env.VUE_APP_APIURL_FBB});
